const root = 'syncList'
const selectAllButton = `${root}-selectAllButton`

export const TestId = {
  selectAllButtonBase: root,
  selectAllButton,
  selectAllButtonSelectAllOnPage: `${selectAllButton}-selectPage`,
  selectAllButtonSelectAll: `${selectAllButton}-selectAll`,
}
